import { createSelector } from '@ngrx/store';
import { TNptState } from './npt.models';
import { TMachineMaintenanceState } from '../reducers';

export const getNptState = (state: TMachineMaintenanceState) => state.nptInfo;

export const getNptLinesDetails = createSelector(getNptState, (state: TNptState) => state.nptLinesDetails);

export const getSelectedDate = createSelector(getNptState, (state: TNptState) => state.selectedDate);

export const getNptWorkstationGroupsDetails = createSelector(
  getNptState,
  (state: TNptState) => state.nptWorkstationsGroups ?? [],
);

export const getWorkstationNpts = createSelector(getNptState, (state: TNptState) => state.workstationsNpts ?? []);

export const getNptReasonsWithDisplayName = createSelector(getNptState, (state: TNptState) => state.nptReasons ?? []);

export const getNptReasonsList = createSelector(getNptState, (state: TNptState) => state.nptReasonsList);
export const getNptReasonsListPaginationOption = createSelector(
  getNptState,
  (state: TNptState) => state.nptReasonsListPaginationOption,
);
